import { ICriteria } from './criteria.interface';
import { ISchedule } from './schedule.interface';

export interface ISetScheduleReportResponse {
  id: number;
  reportId: number;
  reportName: string;
  query: string;
  source: string;
  fields: any[];
  orderCriteria: string;
  direction: string;
  criteria: ICriteria[];
  pageSize: number;
  pageNumber: number;
  organization: string;
  useEntityService: number;
  schedule: ISchedule;
  cronExpression: string;
}
